/**
 * Events emitted by the ZDS3 `z-search` web component.
 *
 * `z-search` owns the input and its keyboard semantics; nav-v2 only reacts.
 * `search-change` fires on every edit, `search-submit` when the user commits
 * the query (Enter).
 */
export const SEARCH_CHANGE_EVENT = 'search-change';
export const SEARCH_SUBMIT_EVENT = 'search-submit';

export type SearchChangeEventDetail = {
  value: string;
};

export type SearchSubmitEventDetail = {
  value: string;
};
